/**
 * (c) 2021 Daniel Kruse <d.kruse@atlantisdx.de>, atlantis dx GmbH
 * (c) 2022 Farina Stielert <f.stielert@atlantisdx.de>, atlantis dx GmbH
 */
import $ from 'jquery';
import 'slick-carousel';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Application {
	constructor() {
		this.swiper = null;
	}

	/**
	 * Init
	 */
	init() {
		this.initSwiperSlider();
		this.initSlick();
	}

	/**
	 * Start Swiper-Slider
	 */
	initSwiperSlider() {
		this.swiper = new Swiper('.swiper.tiles-swiper', {
			effect: 'cube',
			grabCursor: true,
			cubeEffect: {
				shadow: false,
				slideShadows: false,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: '.bce.swiper-button-next',
				prevEl: '.bce.swiper-button-prev',
			},
		});

		this.resizeSwiperSlider();
	}

	/**
	 * Initialise the slider buttons
	 */
	checkNavigation() {
		const swiperPrev = document.querySelector(
			'.buhck-slider .swiper-button-prev',
		);
		const swiperNext = document.querySelector(
			'.buhck-slider .swiper-button-next',
		);
		const pagination = document.querySelector(
			'.tiles-swiper .swiper-pagination',
		);
		if ($(window).width() > 992) {
			if (null !== swiperPrev) {
				swiperPrev.style.display = 'flex';
			}
			if (null !== swiperPrev) {
				swiperNext.style.display = 'flex';
			}
			if (null !== swiperPrev) {
				pagination.style.display = 'none';
			}
		} else {
			if (null !== swiperPrev) {
				swiperPrev.style.display = 'none';
			}
			if (null !== swiperPrev) {
				swiperNext.style.display = 'none';
			}
			if (null !== swiperPrev) {
				pagination.style.display = 'block';
			}
		}
	}

	/**
	 * resizeSwiperSlider
	 */
	resizeSwiperSlider() {
		const swiperSlider = $('.swiper.tiles-swiper .swiper-wrapper');
		if (swiperSlider.length > 0) {
			if ($(window).width() < 1200) {
				const sliderTiles = swiperSlider.find('.buhck-tile');
				sliderTiles.unwrap().wrap("<div class='swiper-slide mobile'></div>");
			} else {
				const sliderTilesMobile = swiperSlider.find('.buhck-tile');
				sliderTilesMobile.unwrap();
				for (let i = 0, len = sliderTilesMobile.length; i < len; i += 2) {
					sliderTilesMobile
						.slice(i, i + 2)
						.wrapAll('<div class="swiper-slide"/>');
				}
			}

			this.swiper.update();
			this.checkNavigation();
		}
	}

	/**
	 * Start SlickSlider Text-Media and Staff-Quotes
	 */
	initSlick() {
		const slider = $('.slide-text-media');
		if (slider.length > 0) {
			slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1386,
						settings: {
							arrows: false,
							dots: true,
						},
					},
				],
			});
		}

		const slideTextMediaStream = $('.slide-text-media-stream');
		if (slideTextMediaStream.length > 0) {
			slideTextMediaStream.slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				responsive: [
					{
						breakpoint: 1386,
						settings: {},
					},
					{
						breakpoint: 1250,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
						},
					},
					{
						breakpoint: 425,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
						},
					},
				],
			});
		}

		const staffSlider = $('.slider-staff-quotes');
		if (staffSlider.length > 0) {
			staffSlider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1386,
						settings: {
							arrows: false,
							dots: true,
						},
					},
				],
			});
		}
	}

	/**
	 * On resize Window
	 * @param window
	 */
	responsive(window) {
		this.resizeSwiperSlider(window);
	}
}

/**
 * Get Ready
 */
$(document).ready(() => {
	const application = new Application();
	const win = $(window);

	application.init(win);
	win.resize(() => {
		application.responsive(win);
	});
});
